var _defs, _rect, _line, _rect2, _line2, _rect3, _line3, _path, _polygon, _path2, _polyline, _path3, _path4, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.96,
    y: 169.52,
    width: 4.32,
    height: 4.32
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.19,
    y1: 171.69,
    x2: 187.36,
    y2: 171.69
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.96,
    y: 139.52,
    width: 4.32,
    height: 4.32
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.19,
    y1: 141.69,
    x2: 187.36,
    y2: 141.69
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.96,
    y: 199.92,
    width: 4.32,
    height: 4.32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.19,
    y1: 202.08,
    x2: 191.31,
    y2: 202.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.27,18H102L45.5,67.9V222.77A15.27,15.27,0,0,0,60.73,238H195.27a15.27,15.27,0,0,0,15.23-15.23V33.23A15.27,15.27,0,0,0,195.27,18Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.01 18 101.77 67.82 45.5 67.9 102.01 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.73,96.66h-30.1V80.33c0-9,6.51-12.33,14.89-12.33l10.3,11.35L155.39,68c7.81,0,14.62,2.89,15.51,10.57"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "171 94.65 171 96.67 169.18 96.67 168.99 96.67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.46,46.15a11.65,11.65,0,1,1-23.3,0V41.76a11.65,11.65,0,1,1,23.3,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.14,96.67a18.21,18.21,0,1,1-18.21-18.2A18.2,18.2,0,0,1,187.14,96.67Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.14,
    y1: 102.62,
    x2: 163.01,
    y2: 90.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.01,
    y1: 102.63,
    x2: 175.14,
    y2: 90.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarred);
export default __webpack_public_path__ + "static/media/barred.a1e452e19da5a9b0ec81c011d102204e.svg";
export { ForwardRef as ReactComponent };